import Swal from 'sweetalert2';

// 檢查上傳檔案類型
export default function validateFileType(file, validExts, isShowSuccess) {
    if (!file) return false;

    const fileName = file.name; // 使用 file.name 來獲取文件名稱
    const fileExt = fileName.substring(fileName.lastIndexOf('.')); // 提取副檔名

    if (!fileExt || validExts.indexOf(fileExt) < 0) {
        Swal.fire({
            icon: 'error',
            title: '檔案類型錯誤',
            text: `可上傳副檔名如下： ${validExts.join(', ')}`,
        });
        return false;
    }

    if (isShowSuccess) {
        Swal.fire({
            icon: 'success',
            title: `${fileName} 上傳成功`,
            timer: 800,
        });
    }

    return true;
}
